function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bad6ee;}.cls-2{fill:#bed9ef;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "asiointi");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M547.6,281.77H536.42l50-50c5.4,5.45,11.33,11.45,18,18.17v-12H617.2c0,7.31-.13,14.49.1,21.66a8.23,8.23,0,0,0,2.09,5c5.35,5.58,11,10.93,17.11,17H623.78c-1.71,8.4-3.36,16.5-5,24.59-.57,2.81-1,5.64-1.63,8.43-.73,3.15-2.74,5-6.07,5q-25.38,0-50.77,0c-3.66,0-5.57-2.08-6.26-5.69C552,303.33,549.82,292.76,547.6,281.77Zm13.07,31.17h18.78v-.21h12.7v.33h18.46c2.41-12.44,4.86-24.68,7-37a6,6,0,0,0-1.64-4.37c-5.52-5.78-11.28-11.34-16.9-17-4.39-4.45-8.69-9-13.28-13.74-10.8,10.84-21.08,21.12-31.27,31.48a4.11,4.11,0,0,0-1,3.11C555.83,288.05,558.27,300.53,560.67,312.94Z",
  transform: "translate(-536.42 -231.76)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M595.91,273.59a11.59,11.59,0,0,0-6.24-1.53c-5.49,0-9.72,2.31-11.3,6.43h15.37l-1.58,3.23H577.63a12.23,12.23,0,0,0,0,3.43h13L589,288.38H578.1c1.22,4.4,5.76,7,11.1,7a15,15,0,0,0,8.45-2.64v5a21.87,21.87,0,0,1-8.61,1.94c-4.39,0-8.93-1.11-12.1-3.79a12.64,12.64,0,0,1-4.33-7.54H569l1.58-3.23h1.59a12.23,12.23,0,0,1,0-3.43H569l1.58-3.23h2.17a14.42,14.42,0,0,1,4.33-6.75c4.12-3.57,9.3-4,12.73-4a17.63,17.63,0,0,1,8.35,1.76Z",
  transform: "translate(-536.42 -231.76)"
});

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100.08 87.91",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.0cdc5cb2.svg";
export { ForwardRef as ReactComponent };